import { ReactComponent as AlertTriangleIcon } from 'src/assets/tailwind/alert-triangle.svg';
import { ReactComponent as AnalyticsIcon } from 'src/assets/tailwind/sidebar/analytics.svg';
import { ReactComponent as AppsIcon } from 'src/assets/tailwind/sidebar/apps.svg';
import { ReactComponent as ArrowLeftIcon } from 'src/assets/tailwind/sidebar/arrow-left.svg';
import { ReactComponent as AssistantsIcon } from 'src/assets/tailwind/sidebar/assistants.svg';
import { ReactComponent as BellIcon } from 'src/assets/tailwind/sidebar/bell.svg';
import { ReactComponent as ChevronDownIcon } from 'src/assets/tailwind/sidebar/chevron-down.svg';
import { ReactComponent as ChevronRightIcon } from 'src/assets/tailwind/sidebar/chevron-right.svg';
import { ReactComponent as ConnectorsIcon } from 'src/assets/tailwind/sidebar/connectors.svg';
import { ReactComponent as EditIcon } from 'src/assets/tailwind/sidebar/edit.svg';
import { ReactComponent as HelpCircleIcon } from 'src/assets/tailwind/sidebar/help-circle.svg';
import { ReactComponent as HistoryIcon } from 'src/assets/tailwind/sidebar/history.svg';
import { ReactComponent as LayoutLeftIcon } from 'src/assets/tailwind/sidebar/layout-left.svg';
import { ReactComponent as LogoutIcon } from 'src/assets/tailwind/sidebar/logout.svg';
import { ReactComponent as MaximizeIcon } from 'src/assets/tailwind/sidebar/maximize.svg';
import { ReactComponent as MoreIcon } from 'src/assets/tailwind/sidebar/more.svg';
import { ReactComponent as NewChatIcon } from 'src/assets/tailwind/sidebar/new-chat.svg';
import { ReactComponent as ProjectsIcon } from 'src/assets/tailwind/sidebar/projects.svg';
import { ReactComponent as SearchIcon } from 'src/assets/tailwind/sidebar/search.svg';
import { ReactComponent as SettingsIcon } from 'src/assets/tailwind/sidebar/settings.svg';
import { ReactComponent as SkillsIcon } from 'src/assets/tailwind/sidebar/skills.svg';
import { ReactComponent as StarIcon } from 'src/assets/tailwind/sidebar/star.svg';
import { ReactComponent as StarFilledIcon } from 'src/assets/tailwind/sidebar/star-filled.svg';
import { ReactComponent as TrashIcon } from 'src/assets/tailwind/sidebar/trash.svg';
import { ReactComponent as UsageIcon } from 'src/assets/tailwind/sidebar/usage.svg';
import { ReactComponent as UserIcon } from 'src/assets/tailwind/sidebar/user.svg';
import { ReactComponent as UsersIcon } from 'src/assets/tailwind/sidebar/users.svg';
import { ReactComponent as WorkflowsIcon } from 'src/assets/tailwind/sidebar/workflows.svg';
import { ReactComponent as WorkspacesIcon } from 'src/assets/tailwind/sidebar/workspaces.svg';
import { ReactComponent as CloseIcon } from 'src/assets/tailwind/x-close.svg';

export type SidebarIcon = React.ComponentType<React.SVGProps<SVGSVGElement>>;

export const sidebarIcons = {
  newChat: NewChatIcon,
  assistants: AssistantsIcon,
  search: SearchIcon,
  analytics: AnalyticsIcon,
  usage: UsageIcon,
  apps: AppsIcon,
  workflows: WorkflowsIcon,
  workspaces: WorkspacesIcon,
  connectors: ConnectorsIcon,
  skills: SkillsIcon,
  projects: ProjectsIcon,
  chevronDown: ChevronDownIcon,
  chevronRight: ChevronRightIcon,
  history: HistoryIcon,
  layoutLeft: LayoutLeftIcon,
  bell: BellIcon,
  arrowLeft: ArrowLeftIcon,
  user: UserIcon,
  users: UsersIcon,
  settings: SettingsIcon,
  maximize: MaximizeIcon,
  more: MoreIcon,
  edit: EditIcon,
  trash: TrashIcon,
  star: StarIcon,
  starFilled: StarFilledIcon,
  logout: LogoutIcon,
  helpCircle: HelpCircleIcon,
  close: CloseIcon,
  alertTriangle: AlertTriangleIcon
} satisfies Record<string, SidebarIcon>;

export type SidebarIconName = keyof typeof sidebarIcons;
